// Generated by CoffeeScript 2.7.0
require('./itself.js');
